// 14-B5 paid its App.tsx lines the way this roadmap likes best: MOVE THE DATA (R37/R42).
//
// **THIS IS THE BLANK EVERY PERSON OF INTEREST STARTS AS**, and it is the only declaration of that
// shape on the client: `personForm` is initialised from it, the People list is TYPED from it, the
// edit modal is typed from it, and saving resets to it. It sat inside `MyRoomPage`, a component
// holding thirty hooks, so nothing could ever load it — which matters here more than it looks,
// because this shape is the RECEIVING END of the three shared birth-field blocks.
//
// R12/N19-1's lesson one room over: those blocks emit PATCHES (`{ birthplace, latitude, longitude,
// timezone }`, `{ birthTime, birthPeriod }`, `{ firstName, middleName, lastName }`), and a key with
// no home in this object lands on a form that never carries it to the server. Nothing throws. Out
// here a gate holds the blank against the real patch keys.
//
// It imports NOTHING — the entry requirement that lets a `.mjs` gate load and RUN it.

export type PersonForm = {
  name: string;
  firstName: string;
  middleName: string;
  lastName: string;
  relationship: string;
  birthDate: string;
  birthTime: string;
  birthPeriod: "AM" | "PM";
  birthTimeUnknown: boolean;
  birthplace: string;
  birthRegion: string;
  birthCountry: string;
  latitude: string;
  longitude: string;
  timezone: string;
  // R118: the place blocks answer the IANA zone name on EVERY resolved place now, rather than only
  // when the geocoder supplied one — an omitted key is merged as the LAST place's zone, which is
  // what the round closed. So this shape receives it, and it gets a home rather than landing on a
  // form that has no column for it. Nothing reads a PERSON'S zone name today (only her own current
  // location is measured against one), and it costs a blank string to be honest about what arrives.
  timezoneName: string;
};

// Every field is blank except the meridiem, which is a CHOICE with no empty state: an unset
// `birthPeriod` renders a select with nothing selected and casts a chart twelve hours out.
export const EMPTY_PERSON: PersonForm = {
  name: "",
  firstName: "",
  middleName: "",
  lastName: "",
  relationship: "",
  birthDate: "",
  birthTime: "",
  birthPeriod: "AM",
  birthTimeUnknown: false,
  birthplace: "",
  birthRegion: "",
  birthCountry: "",
  latitude: "",
  longitude: "",
  timezone: "",
  timezoneName: "",
};
